require('prelude');
module.exports = require('./js/bootstrap');
require('./js/tooltip.js');
require('./js/popover.js');
require('./js/collapse.js');
require('./js/carousel.js');
require('./js/dropdown.js');
require('./js/datepicker.js');
require('./js/touchspin.js');
require('./js/toggle.js');
require('./js/modal.js');
require('./js/label-for.js');
require('./js/faq.js');
require('./js/tab.js');


